import React from 'react'
import _ from "lodash"
import moment from "moment"
import Select from "react-select"
import Datetime from "react-datetime"
import { Input } from "reactstrap";

import { errorMessage } from "./validations"
// import CheckboxGroup, { checkboxesHandler } from './CheckBoxGroup'
//import ImageUpload from "../../../../components/CustomUpload/ImageUpload"
// import ImageUpload from "../ImageUpload"
import convertToHtml from './convertDraftjsToHtml'

function FormField(props) {

   let { input, onChange, isReadOnly } = props
   let { required, type, value, state, label = '', inputType, stateName } = input

   let selectedOpt, readonlyLabelStyle = {}

   if (isReadOnly)
      readonlyLabelStyle = { fontWeight: 'bolder', color: 'black' }

   switch (type) {
      case "Header":
      case "Label":
      case "Paragraph":
         return <div dangerouslySetInnerHTML={{ __html: convertToHtml(label) }} />

      case "LineBreak":
         return <hr />


      case "TextInput":
      case "TextArea":
      case "NumberInput":
         let generalFields = ['email', 'password', 'confirmPassword']

         return (
            <>

               {label && (
                  <div style={{ display: 'flex', ...readonlyLabelStyle }}>
                     <div dangerouslySetInnerHTML={{ __html: convertToHtml(label) }} />
                     <span className='text-danger px-1'>{required ? '*' : ''}</span>
                  </div>
               )}

               {isReadOnly ?
                  <p className='px-2'>{(value && value !== '') ? value : 'No Answer'}</p>
                  :
                  <>
                     <Input
                        name={input.stateName}
                        id={input.stateName}
                        type={inputType ?? (type === 'TextArea' ? 'textarea' : type === 'NumberInput' ? 'number' : 'text')}
                        autoComplete="off"
                        // defaultValue={_.get(input, 'default', '')}
                        value={value ?? ''}
                        onChange={e => onChange(e, input.stateName, type, required)}
                     // placeholder={input.placeholder ? input.placeholder : null}
                     // maxLength={_.get(input, 'validation.maxLength', null)}
                     />

                     {state === "has-danger" && (
                        <label className="error" style={{ color: "red" }}>{errorMessage(generalFields.includes(stateName) ? stateName : (type === 'NumberInput' ? 'number' : 'required'))}</label>
                     )}
                  </>
               }

            </>
         )

      case "TextInputDueDate": // used in due date field
      case "TextInputDate":

         var yesterday = Datetime.moment().subtract(1, 'day')
         var valid = (current) => type === 'TextInputDueDate' ? current.isAfter(yesterday) : true

         return (
            <DateField
               input={input}
               valid={valid}
               onChange={onChange}
               isReadOnly={isReadOnly}
               readonlyLabelStyle={readonlyLabelStyle}
            />
         )


      case "Dropdown":

         if (isReadOnly) {
            selectedOpt = _.find(input.options, opt => opt.id === value)
         }

         return (
            <>
               {label && (
                  <div style={{ display: 'flex', ...readonlyLabelStyle }}>
                     <div dangerouslySetInnerHTML={{ __html: convertToHtml(label) }} />
                     <span className='text-danger px-1'>{required ? '*' : ''}</span>
                  </div>
               )}

               {isReadOnly ?
                  <p className='px-2'>{_.get(selectedOpt, 'value', 'No Answer')}</p>
                  :
                  <>
                     <Input
                        type="select"
                        name={input.stateName}
                        id={input.stateName}
                        value={value ?? ''}
                        onChange={e => onChange(e, input.stateName, type, required)}
                     >
                        <option value='' disabled className='py-2'>Select</option>
                        {_.map(input.options, opt => (
                           <option value={opt.id} key={opt.id} className='py-2'>{opt.value}</option>
                        ))}

                     </Input>

                     {state === "has-danger" && (
                        <label className="error" style={{ color: "red" }}>{errorMessage('required')}</label>
                     )}
                  </>
               }

            </>

         )

      case "Dropdown2": // for staff form + redirect field at the request form

         return (
            <>
               {
                  isReadOnly ?
                     <p className='px-2'>{_.map(value, 'label') ?? 'No Answer'}</p>
                     :
                     <>

                        <Select
                           id={input.stateName}
                           isClearable={_.get(input, 'isClearable', false)}
                           isMulti={_.get(input, 'isMulti', false)}
                           className="react-select primary"
                           classNamePrefix="react-select"
                           // defaultValue={_.get(input, 'default', null)}
                           value={value}
                           onChange={e => onChange(e, input.stateName, type, required)}
                           options={input.options}
                        />

                        {state === "has-danger" && (
                           <label className="error" style={{ color: "red" }}>{errorMessage('required')}</label>
                        )}
                     </>
               }
            </>

         )

      // group
      case "Checkboxes":
      case "RadioButtons":

         if (isReadOnly) {
            selectedOpt = _.filter(input.options, opt => opt.checked)
         }

         return (
            <>
               {label && (
                  <div style={{ display: 'flex', ...readonlyLabelStyle }}>
                     <div dangerouslySetInnerHTML={{ __html: convertToHtml(label) }} />
                     <span className='text-danger px-1'>{required ? '*' : ''}</span>
                  </div>
               )}

               {isReadOnly ?
                  <div className='px-2'>{
                     _.map(selectedOpt, opt =>
                        <p className='p-0 m-0'>{(opt?.label ?? opt?.value)}</p>
                     )}
                  </div>
                  :
                  <>
                     {_.map(input.options, opt => (
                        <div className="form-group" key={opt.id}>
                           <div className={`custom-control ml-3 custom-${type === "Checkboxes" ? "checkbox" : "radio"}`}>
                              <Input
                                 type={type === "Checkboxes" ? "checkbox" : "radio"}
                                 className="custom-control-input"
                                 checked={opt.checked}
                                 onChange={e => onChange(e, input.stateName, type, required)}
                                 id={opt.id} />
                              <label className="custom-control-label" style={{ paddingTop: '2px' }} htmlFor={opt.id}>{opt.label ?? opt.value ?? ''}</label>
                           </div>
                        </div>
                     ))}



                     {state === "has-danger" && (
                        <label className="error" style={{ color: "red" }}>{errorMessage('required')}</label>
                     )}
                  </>
               }


            </>

         )

      default:
         return <></>
   }
}

export default FormField

let DateField = ({ valid, onChange, input, isReadOnly, readonlyLabelStyle }) => (
   <>

      {input.label && (
         <div style={{ display: 'flex', ...readonlyLabelStyle }}>
            <div dangerouslySetInnerHTML={{ __html: convertToHtml(input.label) }} />
            <span className='text-danger px-1'>{input.required ? '*' : ''}</span>
         </div>
      )}

      {isReadOnly ?
         <p className='px-2'>{input.value ? moment(input.value.toDate()).format('DD/MM/YYYY') : "No Answer"}</p>
         :
         <>
            <Datetime
               inputProps={{
                  className: "form-control",
                  readOnly: true, //Disable manually typing
                  color: "white",
                  style: { backgroundColor: "white" },
               }}
               onkeydown="return false"
               closeOnSelect={true}
               timeFormat={false}
               value={input.value ? moment(input.value.seconds * 1000) : ""}
               isValidDate={valid}
               onChange={e => onChange(e, input.stateName, input.type, input.required)}
               inputProps={{
                  className: "form-control"
               }} />

            {input.state === "has-danger" && (
               <label className="error" style={{ color: "red" }}>{errorMessage(input.type === 'NumberInput' ? 'number' : 'required')}</label>
            )}
         </>
      }
   </>
)
